import React, { useState, useEffect, useRef } from "react";
import {
  FaBars,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaUser,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuth } from "../context/auth"; // Import useAuth from your context
import { AnimatePresence, motion } from "framer-motion";

const MenuItem = ({ item, isMobile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOpen = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (item.children) {
    return (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        className={isMobile ? "w-full" : "relative"}
        ref={dropdownRef}
      >
        <button
          className={`flex gap-3 items-center justify-between w-full ${
            isMobile
              ? "px-3 py-2 bg-orange-500 text-white"
              : "hover:text-yellow-400"
          }`}
          onClick={toggleOpen}
        >
          <div></div>
          <span>{item.label}</span>
          {isOpen ? (
            <FaChevronUp className="w-4 h-4" />
          ) : (
            <FaChevronDown className="w-4 h-4" />
          )}
        </button>
        {isOpen && (
          <div
            className={`${
              isMobile
                ? "bg-orange-500 pl-4"
                : "absolute left-0 mt-2 w-64 z-50 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
            } max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
          >
            {item.children.map((child, index) => (
              <Link
                key={index}
                to={child.to}
                className={`block px-4 py-2 text-sm ${
                  isMobile
                    ? "text-black hover:bg-gray-600"
                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                }`}
              >
                {child.label}
              </Link>
            ))}
          </div>
        )}
      </motion.div>
    );
  }

  return (
    <Link
      to={item.to}
      className={`block ${
        isMobile
          ? "px-3 py-2 hover:bg-gray-700 text-white"
          : "hover:text-yellow-500"
      }`}
    >
      {item.label}
    </Link>
  );
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Use authentication context
  const [auth, setAuth] = useAuth();

  const toggleProfileDropdown = () =>
    setIsProfileDropdownOpen(!isProfileDropdownOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    // Clear the auth context state
    setAuth({ user: null, token: "" });

    localStorage.removeItem("auth"); // Remove from local storage
    localStorage.removeItem("token");

    localStorage.clear();

    // Optionally, redirect to the login page
    window.location.href = "/sign_in"; // Redirect to the login page
    // Force a page reload to reset everything
    window.location.reload();
  };

  const menuItems = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    {
      label: "License",
      children: [
        { label: "Driving License", to: "/driving_Lic" },
        { label: "Food License", to: "/food_lic" },
        { label: "Shop Act License", to: "/shop_act" },
        { label: "Income certificate", to: "/income_certificate" },
        { label: "Voter ID", to: "/votter_id" },
        { label: "Passport", to: "/passport" },
        { label: "Gazette Rajpatra", to: "/gazzette" },

      ],
    },
    {
      label: "All Services",
      children: [
        { label: "PAN Services (NSDL)", to: "/pan_service" },
        { label: "Shop Act License", to: "/shop_act" },
        { label: "Food Services (FASSI)", to: "/food_lic" },
        { label: "Passport", to: "/passport" },
        { label: "Driving License", to: "/driving_Lic" },
        { label: "GST Registration", to: "/gst_registration" },
        { label: "Company Registration", to: "/company_registration" },
        { label: "Gazette Rajpatra", to: "/gazzette" },
        { label: "Income certificate", to: "/income_certificate" },
        { label: "Trademark", to: "/tredmark" },
        { label: "Ration Card", to: "/ration" },
        { label: "Import Export Code Registration", to: "/import_Export" },
        { label: "Digital signature", to: "/digital_signature" },
        { label: "Legal consultancy", to: "/legal_consultancy" },
        { label: "Domicile certificate", to: "/domicie" },
        { label: "Udyam Aadhar", to: "/uddyam_aadhar" },
        { label: "Voter ID", to: "/votter_id" },
        { label: "ITR Filing Online", to: "/itr_filing_online" },
        { label: "IT Services", to: "/it_services" },
        { label: "Kisan Point", to: "/kisan_point" },
      ],
    },

    {
      label: "Company Registration",
      children: [
        { label: "   ---- INCORPORATION ----" },
        { label: "Private Limited Company", to: "/pvt_ltd_company" },
        { label: "LLP Registration", to: "/llp_registration" },
        { label: "One Person Company", to: "/one_person_company" },
        { label: "Public Limited Company", to: "/public_limited_company" },
        { label: "Section 8 Company", to: "/section_8_company" },
        {
          label: "Business Registration License",
          to: "/business_registration",
        },
        { label: "Nidhi Registration License", to: "/nidhi_registration_lic" },
        { label: "India Subsidiary Registration", to: "/india_subdiary_lic" },
        { label: "   ---- COMPLIANCE ----" },
        { label: "Director DIN e KYC Update", to: "/director_DIN_eKYC_update" },
        { label: "Appointment of Director", to: "/appointment_director" },
        { label: "Removal of Director", to: "/removal_director" },
        { label: "Pvt. Ltd. Winding up", to: "/pvt_ltd_winding_up" },
        { label: "LLP Winding up", to: "/llp_winding_up" },
        {
          label: "Increase Authorized Capital",
          to: "/increase_authorized_capital",
        },
        { label: "Registered Office Change", to: "/registerd_office_change" },
        { label: "Change Company Name", to: "/change_company_name" },
        { label: "MOA Amendment of Pvt. Ltd", to: "/moa_amendmend_pvt_ltd" },
        {
          label: "MOA Amendment of Public Ltd",
          to: "/moa_amendmend_public_ltd",
        },
        { label: "MOA Amendment of Section 8", to: "/moa_amendmend_section8" },
        { label: "Share Transfer", to: "/share_tranfer" },
        { label: "JanSamarth Registration", to: "/jansamarth_registration" },
        {
          label: "Credit Management Analysis",
          to: "/credit_management_analysis",
        },
      ],
    },
    {
      label: "Tax & Compliance",
      children: [
        { label: "GST", to: "/gst" },
        {
          label: "Annual Compliances & Others",
          to: "/annual_compliances_other",
        },
        { label: "Payroll Compliance", to: "/payroll_compliance" },
        { label: "ITR Filing Online", to: "/itr_filing_online" },

      ],
    },
    {
      label: "Legal Consultancy",
      children: [
        { label: "Online Legal Advice", to: "/online_legal_advice" },
        { label: "Legal Notice", to: "/legal_notice" },
        { label: "Advice on Divorce", to: "/advice_on_divorce" },
        { label: "Revenue Legal", to: "/mahsule" },
        { label: "Joint Venture Deed", to: "/joint_venture" },
        { label: "Lease Deed Drafting", to: "/lease_Draft" },
        { label: "Partner Drafting", to: "/partner_draft" },
        { label: "Rent Deed Drafting", to: "/rent_draft" },
        { label: "Documnet Drafting", to: "/Document_Draft" },

      ],
    },
    {
      label: "More",
      children: [
        { label: "Contact", to: "/contact" },
        { label: "Blogs", to: "/blogs" },
        { label: "Gallery", to: "/gallery" },
        { label: "Team", to: "/team" },
        { label: "Reviews", to: "/reviews" },
      ],
    },
  ];
  const [hasRefreshed, setHasRefreshed] = useState(false); // Track if page has been refreshed

  return (
    <header className=" top-0 left-0 w-full z-50 bg-gradient-to-r from-blue-800 to-blue-900 text-white py-2 shadow-lg">
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        className="container mx-auto mb-2 max-w-[1300px]"
      >
        <div className="flex lg:justify-center justify-between items-center px-3 lg:px-1">
          <h1 className="block md:hidden text-center mb-2 px-3">
            <span className="text-3xl font-bold text-[#03ac26]">
              Make Easy{" "}
            </span>
            <span className="text-2xl font-bold text-[#fe3600]">Documents</span>{" "}
            <br />
            <span className="text-xl font-semibold"> Documents </span> Is Now
            <span className="text-xl font-semibold"> Simple</span>
          </h1>

          <nav
            className="hidden md:flex space-x-3 items-center"
            style={{ padding: "0px 3px", fontSize: "14px", height: "30px" }}
          >
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <MenuItem item={item} isMobile={false} />
                {index !== menuItems.length - 1 && (
                  <div className="border-[1px] border-yellow-400 h-1"></div>
                )}
              </React.Fragment>
            ))}

            {/* Profile Button */}
            <div className="relative">
              {auth.user ? (
                <div ref={dropdownRef} className="profile-button">
                  <button
                    onClick={toggleProfileDropdown}
                    className="flex items-center gap-1 px-3 py-1 bg-orange-500 hover:bg-blue-500 rounded text-sm"
                  >
                    <FaUser className="w-5 h-5" />
                    <FaChevronDown className="w-4 h-4" />
                  </button>
                  {isProfileDropdownOpen && (
                    <div className="absolute right-0 mt-1 w-44 bg-white rounded-md shadow-lg py-1 z-50">
                      <Link
                        to="/dashboard/dashboard"
                        className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        Dashboard
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-3 py-2 text-sm text-gray-700 bg-orange-500 hover:bg-orange-600 rounded"
                      >
                        Log Out
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/sign_in"
                  className="flex items-center gap-1 px-3 py-1 bg-orange-500 hover:bg-blue-500 rounded text-sm"
                >
                  <FaUser className="w-5 h-5" />
                  <span className="text-sm">Log In</span>
                </Link>
              )}
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-3 hover:bg-orange-700 bg-slate-400 rounded transition-colors duration-200"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? (
              <FaTimes className="h-6 w-6" />
            ) : (
              <FaBars className="h-6 w-6" />
            )}
          </button>
        </div>
      </motion.div>

      <div className="container text-slate-700 mx-auto px-3 py-1 bg-[#d6d7da] max-w-[1800px]">
        <div className="flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 md:space-x-2">
          <div className="hidden md:block h-[2px] w-16 lg:w-28 bg-gradient-to-r from-transparent via-yellow-600 to-yellow-600"></div>
          <div className="text-blue-800 hidden md:block text-lg">★</div>
          <p className="text-[10px] md:text-[12px] lg:text-[13px]">
            A Project Powered by{" "}
            <span className="text-blue-800 font-semibold hover:text-blue-700 transition-colors duration-300">
              Viransh Global Legal Pvt Ltd
            </span>
          </p>
          <div className="text-blue-800 hidden md:block text-lg">★</div>
          <div className="hidden md:block h-[2px] w-16 lg:w-28 bg-gradient-to-r from-yellow-600 to-transparent"></div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="block md:hidden py-2 space-y-2 text-center text-sm"
        >
          {menuItems.map((item, index) => (
            <MenuItem key={index} item={item} isMobile={true} />
          ))}
          <div className="px-3">
            {auth.user ? (
              <div className="space-y-2">
                <Link
                  to="/dashboard"
                  className="block px-3 py-2 hover:bg-gray-700 text-white text-sm"
                >
                  Dashboard
                </Link>
                <button
                  onClick={handleLogout}
                  className="block w-full px-3 py-2 hover:bg-gray-700 text-white text-sm"
                >
                  Log Out
                </button>
              </div>
            ) : (
              <Link
                to="/sign_in"
                className="block px-3 py-1 hover:bg-gray-500 text-white text-sm"
              >
                Log In
              </Link>
            )}
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
